import { useQuery } from '@tanstack/react-query';
import statusApiFunctions from '../api/status';
import { Queries } from '../types/queries';
import { ComponentStatusCheck } from '../types/componentStatus';
import { useEffect } from 'react';

const useComponentStatusData = (callback: Function) => {
  const { data, isLoading, isError, refetch } = useQuery<Array<ComponentStatusCheck>>({
    queryKey: Object.values(Queries.ComponentStatusList),
    queryFn: async () => await statusApiFunctions.getComponentStatusCheckList(),
    refetchInterval: 300000, //5 min refresh
    refetchOnWindowFocus: false,
  });

  useEffect(() => callback(data), [data]);

  return { data, isLoading, isError, refetch };
};

export default useComponentStatusData;
